"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=cql-patient.interfaces.js.map